module.exports = __webpack_public_path__ + "img/acct_ban.png";